<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear {{$route.meta.nota == 0 ? 'factura':'nota'}}</h2></v-toolbar-title></pre>
                    </v-toolbar>

                    <v-form ref="linea_form" class="mt-3">
                        <v-row>
                            <v-col v-if="factura.nro" cols="5" md="3">
                                <v-text-field
                                    readonly
                                    label="Número"
                                    v-model="factura.nro"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="5" md="3">
                                <date-select
                                    v-model="factura.fecha"
                                    label="Fecha"
                                >
                                </date-select>
                            </v-col>
                            <v-col cols="5" md="3">
                                <date-select
                                    v-model="factura.fecha_vencimiento"
                                    label="Fecha de vencimiento"
                                >
                                </date-select>
                            </v-col>
                            <v-col
                                cols="2"
                                md="3"
                                style="
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: end;
                                "
                            >
                                <v-tooltip right style="margin-bottom: 5px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            fab
                                            dense
                                            @click="volverAtras"
                                            :loading="isloading"
                                            :disabled="isloading"
                                            color="blue"
                                            class="mt-4 mx-3"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon class="white--text"
                                                >mdi-arrow-left-bold-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Volver</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                <!--<v-radio-group v-model="factura.manual" >
                                <h3>Tipo de Factura</h3>
                                    <v-row>
                                        <v-col cols="6">
                                               <v-radio
                                        :label="`Manual`"
                                        :value="true"
                                         ></v-radio>
                                        </v-col>
                                        <v-col cols="6">
                                             <v-radio
                                        :label="`De un Pedido`"
                                        :value="false"
                                    ></v-radio>
                                        </v-col>
                                    </v-row>
                                </v-radio-group>-->

                                <dynamicSelectVue
                                    :title="'Serie'"
                                    :estados="series"
                                    :show="'nombre'"
                                    :itemvalue="'id'"
                                    :value="factura.id_serie"
                                    @create="saveSerie"
                                    @delete="deleteSerie"
                                    @getEstado="getSerieById"
                                    @update="saveSerie"
                                    @changeElement="changeSerie"
                                >
                                    <v-text-field
                                        v-model="serie.nombre"
                                        type="text"
                                        label="Nombre"
                                    >
                                    </v-text-field>
                                </dynamicSelectVue>
                            </v-col>

                            <v-col cols="12" md="6">
                                <clienteSelect
                                    v-model="factura.id_cliente"
                                    label="Cliente"
                                >
                                </clienteSelect>
                                <!--v-autocomplete
                                    v-else
                                    v-model="factura.id_pedido"
                                    :items="pedidos"
                                    item-text="id"
                                    item-value="id"
                                    label="Pedidos"
                                >
                                </!--v-autocomplete-->
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete
                                    v-model="factura.id_orden"
                                    :items="ordenes"
                                    item-text="nro_orden"
                                    item-value="id"
                                    label="Obra"
                                    clearable
                                    :disabled="!factura.id_cliente"
                                    placeholder="Sin obra"
                                >
                                    <template v-slot:selection="{ item }">
                                        {{ item.nombre ? `${item.nro_orden} – ${item.nombre}` : (item.nro_orden || '') }}
                                    </template>
                                    <template v-slot:item="{ item }">
                                        {{ item.nombre ? `${item.nro_orden} – ${item.nombre}` : (item.nro_orden || '') }}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <h2>Datos cliente</h2>
                        <v-row>
                            <v-col cols="6" md="3">
                                <!-- <v-autocomplete
                                    readonly
                                    v-model="factura.id_cliente"
                                    :items="clientes"
                                    item-text="razon_social"
                                    item-value="id"
                                    label="Nombre fiscal"
                                >
                                </v-autocomplete> -->
                                <cliente-select
                                    v-model="factura.id_cliente"
                                    label="Nombre fiscal"
                                    item-text="razon_social"
                                    item-value="id"
                                    readonly
                                />
                            </v-col>
                            <v-col cols="6" md="3">
                                <!-- <v-autocomplete
                                    readonly
                                    v-model="factura.id_cliente"
                                    :items="clientes"
                                    item-text="cif"
                                    item-value="id"
                                    label="CIF"
                                >
                                </v-autocomplete> -->
                                <cliente-select
                                    v-model="factura.id_cliente"
                                    label="CIF"
                                    item-text="cif"
                                    item-value="id"
                                    readonly
                                />
                            </v-col>
                            <v-col cols="6" md="3">
                                <!-- <v-autocomplete
                                    readonly
                                    v-model="factura.id_cliente"
                                    :items="clientes"
                                    item-text="telefono"
                                    item-value="id"
                                    label="Teléfono"
                                >
                                </v-autocomplete> -->

                                <cliente-select
                                    v-model="factura.id_cliente"
                                    label="Teléfono"
                                    item-text="telefono"
                                    item-value="id"
                                    readonly
                                />
                            </v-col>
                            <v-col cols="6" md="3">
                                <!-- <v-autocomplete
                                    readonly
                                    v-model="factura.id_cliente"
                                    :items="clientes"
                                    item-text="email"
                                    item-value="id"
                                    label="Email"
                                >
                                </v-autocomplete> -->
                                <cliente-select
                                    v-model="factura.id_cliente"
                                    label="Email"
                                    item-text="email"
                                    item-value="id"
                                    readonly
                                />
                            </v-col>
                            <v-col cols="6" md="3">
                                <!-- <v-autocomplete
                                    readonly
                                    v-model="factura.id_cliente"
                                    :items="clientes"
                                    item-text="direccion_nombre"
                                    item-value="id"
                                    label="Dirección"
                                >
                                </v-autocomplete>
                                -->
                                <cliente-select
                                    v-model="factura.id_cliente"
                                    label="Dirección"
                                    item-text="direccion"
                                    item-value="id"
                                    readonly
                                />
                            </v-col>
                            <v-col cols="6" md="3">
                                <!-- <v-autocomplete
                                    readonly
                                    v-model="factura.id_cliente"
                                    :items="clientes"
                                    item-text="ciudad_nombre"
                                    item-value="id"
                                    label="Ciudad"
                                >
                                </v-autocomplete> -->
                                <cliente-select
                                    v-model="factura.id_cliente"
                                    label="Ciudad"
                                    item-text="ciudad"
                                    item-value="id"
                                    readonly
                                />
                            </v-col>
                            <v-col cols="6" md="3">
                                <!-- <v-autocomplete
                                    readonly
                                    v-model="factura.id_cliente"
                                    :items="clientes"
                                    item-text="dir.codigo_postal"
                                    item-value="id"
                                    label="Código postal"
                                >
                                </v-autocomplete> -->
                                <cliente-select
                                    v-model="factura.id_cliente"
                                    label="Código postal"
                                    item-text="codigo_postal"
                                    item-value="id"
                                    readonly
                                />
                            </v-col>
                            <v-col cols="6" md="3">
                                <!-- <v-autocomplete
                                    readonly
                                    v-model="factura.id_cliente"
                                    :items="clientes"
                                    item-text="dir.provincia_rel.nombre"
                                    item-value="id"
                                    label="Provincia"
                                >
                                    <template v-slot:selection="data">
                                        <template v-if="data.item.dir != null">
                                            {{
                                                data.item.dir.provincia_rel !=
                                                null
                                                    ? data.item.dir
                                                          .provincia_rel.nombre
                                                    : ""
                                            }}
                                        </template>
                                    </template>
                                </v-autocomplete> -->
                                <cliente-select
                                    v-model="factura.id_cliente"
                                    label="Provincia"
                                    item-text="provincia"
                                    item-value="id"
                                    readonly
                                />
                            </v-col>
                        </v-row>

                        <!-- Agregar lineas de factura -->
                        <h2>Datos de línea</h2>
                        <v-row dense align="end">
                            <v-col
                                v-if="tipo_linea == 0"
                                cols="12"
                                sm="6"
                                :md="lineaOrdenMd"
                            >
                                <v-autocomplete
                                    v-model="linea.id_orden"
                                    :items="ordenes"
                                    item-text="nro_orden"
                                    item-value="id"
                                    label="Órdenes"
                                    :rules="required_val"
                                >
                                    <template v-slot:selection="{ item }">
                                        <span
                                            class="linea-orden-selection"
                                            :title="
                                                item.nombre
                                                    ? `${item.nro_orden} – ${item.nombre}`
                                                    : item.nro_orden || ''
                                            "
                                        >
                                            {{
                                                item.nombre
                                                    ? `${item.nro_orden} – ${item.nombre}`
                                                    : item.nro_orden || ""
                                            }}
                                        </span>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        {{
                                            item.nombre
                                                ? `${item.nro_orden} – ${item.nombre}`
                                                : item.nro_orden || ""
                                        }}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col
                                v-if="tipo_linea == 0 && showTipoHoraLinea"
                                cols="12"
                                sm="6"
                                md="2"
                            >
                                <v-select
                                    v-model="linea.tipo_hora"
                                    :items="opcionesTipoHora"
                                    item-text="label"
                                    item-value="value"
                                    label="Tipo de hora"
                                    clearable
                                    @input="aplicarPrecioCantidadPorTipoHora"
                                    @change="aplicarPrecioCantidadPorTipoHora"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" :md="lineaDescMd">
                                <v-text-field
                                    v-model="linea.descripcion"
                                    label="Descripción"
                                    :rules="required_val"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="2"
                                class="d-flex align-end justify-center pb-1"
                            >
                                <v-btn-toggle
                                    v-model="tipo_linea"
                                    color="primary"
                                    shaped
                                    mandatory
                                    background-color="white"
                                >
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                text
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon
                                                    >mdi-shape-outline</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Obra</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                text
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon
                                                    >mdi-keyboard-variant</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Manual</span>
                                    </v-tooltip>
                                </v-btn-toggle>
                            </v-col>
                        </v-row>
                        <v-row dense align="center" class="linea-fila-importes">
                            <v-col cols="6" sm="4" md="2">
                                <v-text-field-comma
                                    v-model="linea.cantidad"
                                    type="number"
                                    label="Cantidad"
                                    hide-details
                                    :rules="required_val"
                                >
                                </v-text-field-comma>
                            </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <v-text-field-comma
                                    v-model="linea.precio"
                                    type="number"
                                    label="Precio unit."
                                    hide-details
                                    :rules="required_val"
                                >
                                </v-text-field-comma>
                            </v-col>
                            <v-col
                                v-if="$route.meta.nota == 0"
                                cols="6"
                                sm="4"
                                md="2"
                                class="linea-iva-col"
                            >
                                <v-select
                                    v-model="lineaIvaPorcentaje"
                                    :items="opcionesIvaLinea"
                                    item-text="text"
                                    item-value="value"
                                    label="IVA"
                                    hide-details
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="6" sm="4" :md="lineaDctoMd">
                                <v-text-field-comma
                                    v-model="linea.dcto"
                                    type="number"
                                    label="Dcto."
                                    hide-details
                                >
                                </v-text-field-comma>
                            </v-col>
                            <v-col
                                cols="6"
                                sm="4"
                                md="1"
                                class="linea-dcto-toggle-col d-flex justify-center"
                            >
                                <v-btn-toggle
                                    v-model="linea.tipo_dcto"
                                    color="primary"
                                    shaped
                                    mandatory
                                    background-color="white"
                                >
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </v-col>
                            <v-col cols="12" sm="4" :md="lineaBtnMd">
                                <v-btn
                                    @click="openDescripcion()"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    block
                                    >Añadir</v-btn
                                >
                            </v-col>
                        </v-row>

                        <!-- Detalles de lineas -->
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    dense
                                    :headers="lineasHeaders"
                                    hide-default-footer
                                    disable-pagination
                                    :items="factura.lineas"
                                    item-key="id"
                                    class="elevation-1"
                                >
                                    <template v-slot:item.cantidad="{ item }">
                                        {{ item.cantidad | decimalComma }}
                                    </template>
                                    <template v-slot:item.precio="{ item }">
                                        {{ formatPrice(item.precio) }}
                                    </template>
                                    <template v-slot:item.dcto="{ item }">
                                        {{ formatPrice(item.dcto) }}
                                    </template>
                                    <template v-slot:item.subtotal="{ item }">
                                        {{ formatPrice(item.subtotal, 2) }}
                                    </template>
                                    <template v-slot:item.total="{ item }">
                                        {{ formatPrice(item.total, 2) }}
                                    </template>
                                    <template
                                        v-if="$route.meta.nota == 0"
                                        v-slot:item.iva_pct="{ item }"
                                    >
                                        {{ etiquetaIva(item) }}
                                    </template>
                                    <template v-slot:item.dcto_total="{ item }">
                                        {{
                                            formatPrice(CalcularTotalDcto(item))
                                        }}
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <v-icon
                                            @click="openEditDialog(item)"
                                            small
                                            class="mr-2"
                                            color="black"
                                            style="font-size: 25px"
                                            title="EDITAR"
                                            >mdi-pencil-outline</v-icon
                                        >

                                        <v-icon
                                            @click="openDeleteDialog(item)"
                                            small
                                            class="mr-2"
                                            color="red"
                                            style="font-size: 25px"
                                            title="BORRAR"
                                            >mdi-trash-can</v-icon
                                        >
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>

                        <!-- Totales -->
                        <v-row align="start" justify="end">
                            <v-col cols="12" md="4" offset-md="8">
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <v-row>
                                        <v-col cols="6">
                                            <h4>
                                                {{
                                                    $route.meta.nota == 1
                                                        ? "Total:"
                                                        : "Base imponible:"
                                                }}
                                            </h4>
                                        </v-col>
                                        <v-col cols="6">
                                            <h4>{{ formatPrice(total, 2) }} €</h4>
                                        </v-col>
                                        <template v-if="$route.meta.nota != 1">
                                            <template
                                                v-for="tipo in tiposIvaEnTotales"
                                            >
                                                <v-col
                                                    :key="'iva-label-' + tipo"
                                                    cols="6"
                                                >
                                                    <h4>
                                                        IVA {{ tipo }} %
                                                        <span
                                                            class="caption grey--text"
                                                        >
                                                            ({{
                                                                desgloseDetalle[
                                                                    tipo
                                                                ].count
                                                            }}
                                                            {{
                                                                desgloseDetalle[
                                                                    tipo
                                                                ].count === 1
                                                                    ? "línea"
                                                                    : "líneas"
                                                            }},
                                                            base
                                                            {{
                                                                formatPrice(
                                                                    desgloseDetalle[
                                                                        tipo
                                                                    ].base,
                                                                    2
                                                                )
                                                            }}
                                                            €)
                                                        </span>
                                                    </h4>
                                                </v-col>
                                                <v-col
                                                    :key="'iva-val-' + tipo"
                                                    cols="6"
                                                >
                                                    <h4>
                                                        {{
                                                            formatPrice(
                                                                desgloseDetalle[
                                                                    tipo
                                                                ].cuota,
                                                                2
                                                            )
                                                        }}
                                                        €
                                                    </h4>
                                                </v-col>
                                            </template>
                                            <v-col cols="6">
                                                <h4>Total factura:</h4>
                                            </v-col>
                                            <v-col cols="6">
                                                <h4>
                                                    {{
                                                        formatPrice(
                                                            totalConIva,
                                                            2
                                                        )
                                                    }}
                                                    €
                                                </h4>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!-- Observaciones -->
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="factura.observaciones"
                                    label="Obersevaciones"
                                    outlined
                                >
                                </v-textarea>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="factura.observaciones_internas"
                                    label="Obersevaciones internas"
                                    outlined
                                >
                                </v-textarea>
                            </v-col>
                            <v-col cols="12" md="6">
                                <MetodosDePagoSelect
                                    v-model="factura.id_metodo_pago"
                                />
                            </v-col>
                            <v-col
                                v-if="esTransferenciaBancaria"
                                cols="12"
                                md="6"
                            >
                                <CuentasBancariasSelect
                                    v-model="factura.id_cuenta_bancaria"
                                    @cuenta-selected="onCuentaBancariaSelected"
                                />
                            </v-col>
                        </v-row>

                        <!-- Botones de acciones del formulario -->
                        <v-row>
                            <v-col cols="12">
                                <router-link :to="$route.meta.lista">
                                    <v-btn color="red" class="white--text mr-2">
                                        Cancelar
                                    </v-btn>
                                </router-link>

                                <v-btn
                                    v-if="!factura.id"
                                    @click="saveFactura"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-if="factura.id"
                                    @click="saveFactura"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="factura.id"
                                    @click="isConfirmDialogVisible = true"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Duplicar</v-btn
                                >
                                <v-btn
                                    v-if="factura.id"
                                    @click="openAsiento"
                                    color="green"
                                    class="white--text mr-2"
                                    >Abrir asiento</v-btn
                                >
                                <router-link
                                    :to="{
                                        path: `/${$route.meta.abonos}?id=${factura.id}`,
                                    }"
                                >
                                    <v-btn
                                        v-if="factura.id"
                                        :disabled="isloading"
                                        color="blue"
                                        class="white--text mr-2"
                                        >Abonos</v-btn
                                    >
                                </router-link>
                                <v-btn
                                    v-if="factura.id"
                                    :to="`guardar-cliente?id=${factura.id_cliente}`"
                                    color="info"
                                    plain
                                    outlined
                                    class="white--text"
                                    >Ver cliente</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>

        <!-- Anadir dialog (al dar click en anadir abre la descripcion) -->
        <v-dialog v-model="product_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Descripción del producto
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="linea.descripcion"
                                type="text"
                                label="Descripción del producto"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn
                        color="success"
                        large
                        @click="
                            addLinea();
                            product_dialog = false;
                            addAnticipo();
                        "
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- edit dialog -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Editar línea
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-text-field
                                v-model="editlinea.articulo"
                                type="text"
                                label="Artículo"
                            >
                            </v-text-field>
                        </v-col>

                        <template v-if="$route.meta.nota == 1">
                            <v-col cols="12" md="6">
                                <div class="spacing">
                                    <v-text-field-comma
                                        v-model="editlinea.cantidad"
                                        type="number"
                                        label="Cantidad"
                                    >
                                    </v-text-field-comma>
                                </div>
                            </v-col>
                            <v-col
                                cols="12"
                                :md="$route.meta.nota == 1 ? '6' : '4'"
                            >
                                <div class="spacing">
                                    <v-text-field-comma
                                        v-model="editlinea.precio"
                                        type="number"
                                        label="Precio unitario"
                                    >
                                    </v-text-field-comma>
                                </div>
                            </v-col>
                        </template>
                        <template v-else>
                            <v-col cols="12">
                                <div>
                                    <h5>
                                        Puede escribir el precio unitario o el
                                        precio total
                                    </h5>

                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <div class="spacing">
                                                <v-text-field-comma
                                                    v-model="editlinea.cantidad"
                                                    type="number"
                                                    label="Cantidad"
                                                >
                                                </v-text-field-comma>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="spacing">
                                                <v-text-field-comma
                                                    v-model="editlinea.precio"
                                                    type="number"
                                                    @input="TotalFromBase"
                                                    label="Precio unitario"
                                                >
                                                </v-text-field-comma>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="spacing">
                                                <v-text-field-comma
                                                    v-model="
                                                        editlinea.precio_total
                                                    "
                                                    type="number"
                                                    label="Precio total"
                                                    @input="BaseFromTotal"
                                                >
                                                </v-text-field-comma>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </template>

                        <v-col cols="12">
                            <div class="spacing">
                                <v-textarea
                                    v-model="editlinea.descripcion"
                                    label="Descripción"
                                >
                                </v-textarea>
                            </div>
                        </v-col>
                        <v-col
                            v-if="$route.meta.nota == 0"
                            cols="12"
                            md="3"
                            class="iva-linea-col"
                        >
                            <div class="caption mb-1">IVA</div>
                            <v-btn-toggle
                                v-model="editlineaIvaPorcentaje"
                                mandatory
                                dense
                                color="primary"
                                class="iva-linea-toggle"
                            >
                                <v-btn :value="21" small>21 %</v-btn>
                                <v-btn :value="10" small>10 %</v-btn>
                                <v-btn :value="0" small>0 %</v-btn>
                            </v-btn-toggle>
                        </v-col>
                        <v-col v-if="editlinea.id_orden" cols="12">
                            <v-select
                                v-model="editlinea.tipo_hora"
                                :items="opcionesTipoHora"
                                item-text="label"
                                item-value="value"
                                label="Tipo de hora"
                                clearable
                                outlined
                                dense
                                @input="() => aplicarPrecioCantidadPorTipoHora(editlinea)"
                                @change="() => aplicarPrecioCantidadPorTipoHora(editlinea)"
                            >
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <div style="display: flex">
                                <v-text-field-comma
                                    v-model="editlinea.dcto"
                                    type="number"
                                    label="Descuento"
                                >
                                </v-text-field-comma>
                                <v-btn-toggle
                                    color="primary"
                                    shaped
                                    v-model="editlinea.tipo_dcto"
                                    background-color="white"
                                >
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="success" large @click="Edit()"
                        >Modificar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--delete dialog-->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="delete_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteLinea()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog de asiento contable -->
        <DialogLibroDiario
            v-model="asiento_dialog"
            :id_factura="factura.id"
            :extra="facturaAsiento"
            :id_cliente="factura.id_cliente"
        ></DialogLibroDiario>

        <!-- Confirmar duplicar factura dialog-->
        <CustomDialog
            v-model="isConfirmDialogVisible"
            title="Duplicar factura"
            width="500px"
            @submit="duplicarFactura"
        >
            <div>
                <p class="mb-4">Indica la fecha de la factura nueva para que se asigne el año fiscal correcto.</p>
                <date-select
                    v-model="fechaFacturaDuplicada"
                    label="Fecha de la factura nueva"
                >
                </date-select>
            </div>
        </CustomDialog>
    </v-container>
</template>

<script>
import moment from "moment";
import { debounce } from "../../../helpers";
import DialogLibroDiario from "../../libroDiario/componentes/DialogLibroDiario.vue";
import dynamicSelectVue from "../../../components/general/dynamicSelect.vue";
import clienteSelect from "../../../components/general/clienteSelect.vue";
import { addDays, currentDay } from "../../../components/general/DateFunctions";
import { mdiStarThreePointsOutline } from "@mdi/js";
import { addFacturaAnticipoNegativa } from "../js/Anticipo";
import MetodosDePagoSelect from "../../../components/general/MetodosDePagoSelect.vue";
import CuentasBancariasSelect from "../../../components/general/CuentasBancariasSelect.vue";
import CustomDialog from "../../../components/general/dialogs/CustomDialog.vue";
import { formatPrice } from "../../../helpers";

export default {
    components: {
        dynamicSelectVue,
        DialogLibroDiario,
        clienteSelect,
        MetodosDePagoSelect,
        CuentasBancariasSelect,
        CustomDialog,
    },
    data() {
        return {
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            required_val_0: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
                (v) => v != 0 || "El campo no puede ser 0",
            ],

            refresh_key: 0,

            asiento_dialog: false,
            dialog: false,
            delete_dialog: false,
            product_dialog: false,
            isConfirmDialogVisible: false,
            fechaFacturaDuplicada: null,

            ivas: [],
            factura: {
                id: null,
                incluir_iva: true,
                iva: 21,
                iva_21: 0,
                iva_10: 0,
                iva_0: 0,
                lineas: [],
                manual: true,
                id_pedido: null,
                id_presupuesto: null,
                presupuesto: {},
                id_serie: null,
                id_cliente: null,
                id_orden: null,
                id_cuenta_bancaria: null,
                fecha: currentDay(),
                fecha_vencimiento: currentDay(),
                total: 0,
            },
            metodosDePago: [],
            headersBase: [
                { text: "Descripción", value: "descripcion", sortable: false },
                { text: "Cantidad", value: "cantidad", sortable: false },
                { text: "Precio unidad", value: "precio", sortable: false },
                { text: "Subtotal", value: "subtotal", sortable: false },
                { text: "Descuento", value: "dcto", sortable: false },
                { text: "Total", value: "total", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],

            tipo_linea: 0,
            linea: {
                id: null,
                descripcion: "",
                articulo: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 1,
                dcto: 0,
                total: null,
                precio_unidad: null,
                id_orden: null,
                id_albaran_venta: null,
                tipo_hora: null,
                id_iva: null,
            },
            editlinea: {
                id: null,
                descripcion: null,
                cantidad: null,
                precio: null,
                precio_total: 0,
                total: null,
                tipo_dcto: 0,
                dcto: 0,
                total: null,
                articulo: null,
                precio_unidad: null,
                id_orden: null,
                id_albaran_venta: null,
                tipo_hora: null,
                id_iva: null,
            },

            metodos_pagos: [],
            albaranes_venta: [],
            ordenes: [],
            productos: [],
            series: [],

            factura_anticipo: {},
            serie: {
                id: null,
                nombre: "",
            },
            cliente: {},
            orden: {},
            opcionesTipoHora: [
                { value: "normal", label: "Hora normal" },
                { value: "extra", label: "Hora nocturna" },
                { value: "festivo", label: "Hora fin de semana / festivo" },
            ],
        };
    },
    watch: {
        isConfirmDialogVisible(val) {
            if (val) {
                this.fechaFacturaDuplicada = currentDay();
            }
        },
        "factura.id_cliente": function (val) {
            this.$store.dispatch("getDataCliente", val);
            this.getOrdenesCliente();
            this.getMetodoCliente();
            this.getAlbaranesVentaCliente();
            this.getCliente(val);
        },
        "factura.id_pedido": function (val) {
            this.$store.dispatch("getLineas", val);
        },
        "factura.id_metodo_pago": function (val) {
            this.getMetodoCliente();
            if (!this.esTransferenciaBancaria) {
                this.factura.id_cuenta_bancaria = null;
            }
        },
        "linea.id_orden": {
            handler(val) {
                this.selectOrdenCliente();
            },
            immediate: true,
        },
        "linea.tipo_hora"(val) {
            if (!val || !this.linea.id_orden) {
                return;
            }
            this.$nextTick(() => {
                this.orden = this.findOrden(this.linea.id_orden);
                this.aplicarPrecioCantidadPorTipoHora();
            });
        },
        "editlinea.tipo_hora"(val) {
            if (!val || !this.editlinea.id_orden) {
                return;
            }
            this.$nextTick(() => {
                this.aplicarPrecioCantidadPorTipoHora(this.editlinea);
            });
        },
        factura_anticipo: {
            handler(val) {
                if (!val) {
                    console.log("Anticipo no encontrado");
                    return;
                }

                //this.linea.cantidad = 1;
                //this.linea.precio = -val.lineas_rel[0].precio; //con valor negativo
                //this.linea.descripcion = val.lineas_rel[0].articulo;

                //this.addLinea();
            },
            immediate: true,
        },
        "linea.id_albaran_venta": {
            handler(val) {
                this.selectAlbaranVentaCliente();
            },
            immediate: true,
        },
        tipo_linea: function (val) {
            this.clearLinea();
        },
    },
    created() {
        //NOTA: TODOS LOS COMENTARIOS REALIZADOS REFERENTES AL MODULO DE "FACTURACION" PUEDEN ELIMINARSE SI LO CONSIDERA PRECISO.
        //      EN ESTE MOMENTO NO FUERON ELIMINADOS DEBIDO A QUE CONSTANTEMENTE SE SOLICITARON CAMBIOS SOBRE SU FUNCIONAMIENTO
        //      Y CONSIDERE PERTINENTE MANTENERLOS "POR SI ACASO", A MODO DE RECUPERARLOS DE SER NECESARIO

        this.$store.dispatch("getPedidos", this);
        this.getIvas();
        if (this.$route.query.id) {
            this.getFactura(this.$route.query.id);
        } else {
            const factura = this.$store.getters.getFactura;
            if (factura != null) {
                // console.log(factura);
                this.$store.dispatch("addCliente", factura.cliente);
                this.$store.dispatch("clearFactura");
                this.factura = factura;
            }

            // No es necesario llamar a las funciones que estalecen los datos de la factura utilizando los estados vuex
            // ya que ya no se redirige a este formulario desde facturacion sino que se crea directamente la factura desde alla
            // si el estado o es null ni un array vacio carga la data de facturas en funcion de el
            /*if(this.state_ordenes.length > 0){
                this.setDataFacturaOrden();
            }

            // si el estado no es null ni un array vacio carga la data de facturas en funcion de el
            if(this.state_albaran_venta.length > 0){
                this.setDataFacturaAlbaran();
            }*/
        }

        if (this.$route.query.id_presupuesto) {
            this.getPresupuesto();
        }
        this.getProductos();
        this.getSeries();
        this.getMetodosDePago();
    },
    methods: {
        volverAtras() {
            this.$router.go(-1);
        },
        // Factura
        getFactura(id) {
            let me = this;
            axios.get(`api/get-factura/${id}`).then(
                (res) => {
                    me.factura = res.data;
                    me.factura.lineas = res.data.lineas;
                    me.orderLineas();
                    this.$store.dispatch("getClientesWithId", {
                        id: me.factura.id_cliente,
                    });
                    if (me.factura.manual == 1) {
                        me.factura.manual = true;
                    } else {
                        me.factura.manual = false;
                    }
                    if (me.factura.nota == 0) {
                        me.factura.iva_21 =
                            parseFloat(me.factura.iva_21) || 0;
                        me.factura.iva_10 =
                            parseFloat(me.factura.iva_10) || 0;
                        me.factura.iva_0 = parseFloat(me.factura.iva_0) || 0;
                        const cuotaDesglose =
                            me.factura.iva_21 +
                            me.factura.iva_10 +
                            me.factura.iva_0;
                        const ivaNum = parseFloat(me.factura.iva) || 0;
                        me.factura.incluir_iva =
                            cuotaDesglose > 0 || ivaNum > 0;
                        me.normalizarIvasLineas();
                    }
                },
                (res) => {}
            );
        },
        saveFactura() {
            this.factura.nota = this.$route.meta.nota;
            this.syncDesgloseIva();

            if (this.factura.nota == 0) {
                this.factura.incluir_iva = this.importeIva > 0;
                if (!this.factura.incluir_iva) {
                    this.factura.iva = 0;
                    this.factura.iva_21 = 0;
                    this.factura.iva_10 = 0;
                    this.factura.iva_0 = 0;
                } else {
                    const c = this.desgloseCuotas;
                    if (c.iva_10 > 0 && c.iva_21 === 0) {
                        this.factura.iva = 10;
                    } else {
                        this.factura.iva = 21;
                    }
                }
            }

            axios
                .post("api/save-factura", this.factura)
                .then((res) => {
                    // Como ya no se redirige a este formulario desde facturacion sino que se crea directamente la factura desde alla
                    // y no se usan los estados no es necesario limpiarlos
                    /*if(this.state_ordenes.length > 0){
                        this.$store.dispatch('clearOrdenesData')
                    }else{
                        this.$store.dispatch('clearAlbaraVentaData')
                    }*/

                    this.$router.push(this.$route.meta.lista);
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        duplicarFactura() {
            this.$store.dispatch("isLoading", true);
            // Esperar a que Vue actualice el DOM antes de ejecutar la petición
            this.$nextTick(() => {
                axios
                    .post(`api/duplicar-factura/${this.factura.id}`, {
                        nota: this.$route.meta.nota,
                        fecha: this.fechaFacturaDuplicada || this.factura.fecha,
                    })
                    .then((res) => {
                        const response = res.data;
                        this.isConfirmDialogVisible = false;

                        let ruta =
                            this.$route.meta.nota == 1
                                ? "guardar-nota"
                                : "guardar-factura";
                        this.$router.push(ruta + "?id=" + response.data.id);

                        this.factura = response.data;
                        this.$toast.success(response.message);
                    });
            });
        },

        // Acciones de las lineas de la factura
        getLinea(linea_l) {
            let linea = linea_l;

            let subtotal = 0;
            if (this.$route.meta.nota == 0) {
                if (linea.id_albaran_venta != null) {
                    if (linea.precio_total != null && linea.precio_total > 0) {
                        const factor = this.ivaFactorLinea(linea);
                        const base_imponible =
                            parseFloat(linea.precio_total) / factor;
                        linea.precio = base_imponible;
                        subtotal = base_imponible * linea.cantidad;
                    } else {
                        subtotal = linea.precio * linea.cantidad;
                    }
                } else {
                    subtotal = linea.precio * linea.cantidad;
                }
            } else {
                subtotal = linea.precio * linea.cantidad;
            }

            // linea.subtotal = linea.precio * linea.cantidad;
            if (linea.tipo_dcto == 0) {
                linea.dcto = (linea.precio * linea.cantidad * linea.dcto) / 100;
                // Mantener tipo_dcto = 0 para que al editar se muestre % seleccionado
            }

            linea.subtotal = subtotal;
            linea.total = linea.subtotal - linea.dcto;

            if (this.$route.meta.nota == 0 && !linea.id_iva) {
                this.asignarIvaPorcentaje(linea, 21);
            }

            return JSON.parse(JSON.stringify(linea));
        },
        getIvas() {
            axios
                .get("api/get-iva")
                .then((res) => {
                    const todos = res.data.success || [];
                    this.ivas = todos.filter((i) =>
                        [21, 10, 0].includes(parseInt(i.descripcion))
                    );
                    if (!this.linea.id_iva) {
                        this.asignarIvaPorcentaje(this.linea, 21);
                    }
                    this.normalizarIvasLineas();
                })
                .catch(() => {});
        },
        normalizarIvasLineas() {
            if (!this.ivas.length || this.$route.meta.nota == 1) {
                return;
            }
            this.factura.lineas.forEach((linea) => {
                if (!linea.id_iva) {
                    const pct =
                        linea.iva && linea.iva.descripcion != null
                            ? parseInt(linea.iva.descripcion)
                            : 21;
                    this.asignarIvaPorcentaje(linea, pct);
                }
            });
            this.syncDesgloseIva();
        },
        idIvaPorPorcentaje(porcentaje) {
            const iva = this.ivas.find(
                (i) => parseInt(i.descripcion) === parseInt(porcentaje)
            );
            return iva ? iva.id : this.defaultIvaId();
        },
        asignarIvaPorcentaje(linea, porcentaje) {
            const pct = [0, 10, 21].includes(parseInt(porcentaje))
                ? parseInt(porcentaje)
                : 21;
            linea.id_iva = this.idIvaPorPorcentaje(pct);
        },
        etiquetaIva(linea) {
            const pct = this.ivaPorLinea(linea);
            return pct > 0 ? `${pct} %` : "0 %";
        },
        cuotaIvaLinea(linea) {
            const base = parseFloat(linea.total) || 0;
            const pct = this.ivaPorLinea(linea);
            if (Math.abs(base) < 0.005 || pct <= 0) {
                return 0;
            }
            return Math.round(((base * pct) / 100) * 100) / 100;
        },
        defaultIvaId() {
            const iva21 = this.ivas.find(
                (i) => parseInt(i.descripcion) === 21
            );
            return iva21 ? iva21.id : this.ivas[0]?.id ?? null;
        },
        ivaPorLinea(linea) {
            const iva = this.ivas.find((i) => i.id == linea.id_iva);
            if (iva) {
                return parseInt(iva.descripcion);
            }
            if (linea.iva && linea.iva.descripcion != null) {
                return parseInt(linea.iva.descripcion);
            }
            return 21;
        },
        ivaFactorLinea(linea) {
            return 1 + this.ivaPorLinea(linea) / 100;
        },
        calcularDesgloseDetalle() {
            const detalle = {
                21: { base: 0, cuota: 0, count: 0 },
                10: { base: 0, cuota: 0, count: 0 },
                0: { base: 0, cuota: 0, count: 0 },
            };
            if (this.$route.meta.nota == 1) {
                return detalle;
            }
            this.factura.lineas.forEach((linea) => {
                const base = parseFloat(linea.total) || 0;
                if (Math.abs(base) < 0.005) {
                    return;
                }
                const pct = this.ivaPorLinea(linea);
                const bucket = pct === 21 ? 21 : pct === 10 ? 10 : 0;
                detalle[bucket].base += base;
                detalle[bucket].cuota += this.cuotaIvaLinea(linea);
                detalle[bucket].count += 1;
            });
            [21, 10, 0].forEach((t) => {
                detalle[t].base = Math.round(detalle[t].base * 100) / 100;
                detalle[t].cuota = Math.round(detalle[t].cuota * 100) / 100;
            });
            return detalle;
        },
        calcularDesgloseCuotas() {
            const detalle = this.calcularDesgloseDetalle();
            return {
                iva_21: detalle[21].cuota,
                iva_10: detalle[10].cuota,
                iva_0: detalle[0].cuota,
            };
        },
        syncDesgloseIva() {
            const cuotas = this.calcularDesgloseCuotas();
            this.factura.iva_21 = cuotas.iva_21;
            this.factura.iva_10 = cuotas.iva_10;
            this.factura.iva_0 = cuotas.iva_0;
        },
        openDescripcion() {
            if (!this.$refs.linea_form.validate()) return;
            // Si el usuario ya escribió la descripción (línea manual), añadir la línea directamente sin popup
            if (this.linea.descripcion && String(this.linea.descripcion).trim() !== "") {
                this.addLinea();
                return;
            }
            this.linea.descripcion = "";
            this.product_dialog = true;
        },
        addLinea() {
            this.factura.lineas.push(this.getLinea(this.linea));
            this.orderLineas();
            this.clearLinea();
        },
        Edit() {
            let index = this.editlinea.index;
            let linea = this.getLinea(this.editlinea);
            // console.log(linea);
            this.factura.lineas[index] = JSON.parse(JSON.stringify(linea));
            const lineas = JSON.parse(JSON.stringify(this.factura.lineas));
            this.factura.lineas = [];
            this.factura.lineas = lineas;
            this.refresh_key++;
            this.dialog = false;
        },
        deleteLinea() {
            let index = this.factura.lineas.indexOf(this.editlinea);

            this.factura.lineas.splice(index, 1);
            this.delete_dialog = false;
        },
        clearLinea() {
            this.linea = {
                id: null,
                descripcion: "",
                articulo: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 0,
                dcto: 0,
                total: null,
                precio_unidad: null,
                id_orden: null,
                id_albaran_venta: null,
                tipo_hora: null,
                id_iva: this.defaultIvaId(),
            };
        },
        openEditDialog(item) {
            this.editlinea = JSON.parse(JSON.stringify(item));
            if (this.$route.meta.nota == 0 && !this.editlinea.id_iva) {
                this.asignarIvaPorcentaje(this.editlinea, 21);
            }
            this.editlinea.index = this.factura.lineas.indexOf(item);
            // Asegurar que tipo_dcto sea 0 (%) o 1 (€) para que el toggle muestre la opción correcta
            if (this.editlinea.tipo_dcto !== 0 && this.editlinea.tipo_dcto !== 1) {
                this.editlinea.tipo_dcto = 0;
            }
            // Si el descuento es en %, mostrar el % en el campo (no el importe); si es en €, dejar el importe
            if (this.editlinea.tipo_dcto === 0) {
                this.editlinea.dcto = this.redondearPctDcto(this.editlinea);
            }
            this.dialog = true;
            this.TotalFromBase();
        },
        openDeleteDialog(item) {
            this.editlinea = item;
            this.delete_dialog = true;
        },
        orderLineas() {
            // Ordenar de manera que los importes negativos queden al final
            this.factura.lineas.sort((a, b) => {
                if (a.total < 0 && b.total >= 0) {
                    return 1; // Mueve los negativos al final
                } else if (a.total >= 0 && b.total < 0) {
                    return -1; // Deja los positivos en la parte superior
                } else {
                    return 0; // Mantén el orden si ambos son positivos o negativos
                }
            });
        },

        getMetodosDePago() {
            axios.get("api/metodos-de-pago").then((res) => {
                this.metodosDePago = res.data.metodos || [];
            });
        },
        onCuentaBancariaSelected(cuenta) {
            let obs = (this.factura.observaciones || "").trim();
            obs = obs.replace(/\n?Transferencia\s*\|\s*[^\n]*\n?/g, "\n").trim();
            if (cuenta && cuenta.numero) {
                obs = obs ? obs + "\nTransferencia |\t" + cuenta.numero : "Transferencia |\t" + cuenta.numero;
            }
            this.factura.observaciones = obs;
        },
        // Serie factura
        getSeries() {
            axios.get(`api/get-series`).then(
                (res) => {
                    this.series = res.data.success;
                },
                (res) => {}
            );
        },
        saveSerie() {
            axios
                .post("api/save-serie", this.serie)
                .then((res) => {
                    this.getSeries();
                    // this.modal_serie = false
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        getSerieById(id) {
            if (id != null) {
                axios
                    .get(`api/get-serie-by-id/${id}`)
                    .then((res) => {
                        this.serie = res.data.success;
                        // this.modal_serie = false
                    })
                    .catch((error) => {
                        if (error.response.code == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Algo salió mal");
                        }
                    });
            }
        },
        changeSerie(item) {
            this.factura.id_serie = item.id;
        },
        deleteSerie(id) {
            axios
                .delete(`api/delete-serie/${id}`)
                .then((res) => {
                    this.getSeries();
                    // this.modal_serie = false
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },

        // Cliente
        getCliente(id) {
            let me = this;
            axios.get(`api/getcliente/${id}`).then(
                (res) => {
                    // console.log('get cliente', res.data)
                    this.cliente = res.data;
                },
                (res) => {}
            );
        },

        // albaranes de venta del cliente
        async getAlbaranesVentaCliente() {
            if (this.factura.id_cliente == null) return;
            try {
                const res = await axios.get(
                    `api/albaran/venta/cliente/${this.factura.id_cliente}`
                );
                if (res.data.success != null) {
                    this.albaranes_venta = res.data.success;
                }
            } catch (err) {}
        },
        async selectAlbaranVentaCliente() {
            let albaran_venta = null;

            if (this.albaranes_venta.length > 0) {
                albaran_venta = this.albaranes_venta.find(
                    (ele) => ele.id == this.linea.id_albaran_venta
                );
            }

            if (!albaran_venta) {
                console.log("Albarán de venta no encontrado");
                return;
            }

            let total = albaran_venta.importe;
            this.linea.cantidad = 1;
            this.linea.precio = total / this.ivaFactorLinea(this.linea);
            this.linea.descripcion = `Nº de albarán ${albaran_venta.nro} - Fecha ${albaran_venta.fecha}`;
        },

        // Metodos de pago asociados al cliente (solo recalcula fecha vencimiento en facturas nuevas)
        async getMetodoCliente() {
            if (
                this.factura.id_cliente == null ||
                this.factura.id_metodo_pago == null
            )
                return;
            // En factura existente no sobrescribir fecha_vencimiento: mantener la guardada o la que el usuario haya puesto
            if (this.factura.id != null) return;
            try {
                const res = await axios.get(
                    `api/cliente/${this.factura.id_cliente}/metodo/${this.factura.id_metodo_pago}`
                );
                if (res.data != null) {
                    this.factura.fecha_vencimiento = addDays(
                        this.factura.fecha ?? currentDay(),
                        res.data.vencimiento ?? 0
                    );
                }
            } catch (err) {}
        },

        // Ordenes del cliente
        async getOrdenesCliente() {
            if (this.factura.id_cliente == null) return;
            const filtros = `&id_cliente=${
                this.factura.id_cliente
            }&paraFacturar=${this.$route.meta.nota == 1 ? 2 : 1}`;
            console.log(filtros);
            const res = await axios.get(
                `api/get-ordenes?amount=${-1}${filtros}`
            );
            this.ordenes = res.data.data;
            // Si la obra seleccionada no es del cliente actual, limpiar
            if (this.factura.id_orden && !this.ordenes.some((o) => o.id === this.factura.id_orden)) {
                this.factura.id_orden = null;
            }
        },

        findOrden(idOrden) {
            if (!idOrden || !this.ordenes.length) {
                return null;
            }
            return this.ordenes.find((ele) => ele?.id == idOrden) || null;
        },

        productosOrden(orden) {
            if (!orden) {
                return [];
            }
            return (
                orden.productos ||
                orden.Productos ||
                orden.productos_orden ||
                []
            );
        },

        // Acciones de factura o presupuesto segun sea el query param enviado
        async selectOrdenCliente() {
            // let orden = null;

            if (this.ordenes.length > 0) {
                this.orden = this.findOrden(this.linea.id_orden);
                // Para traer la factura de anticipo
            } else {
                /*this.orden = this.state_ordenes.find(
                    (ele) => ele.id == this.linea.id_orden
                );*/
            }
            // if (orden == null) return;
            if (!this.orden) {
                console.log("Orden no encontrada");
                return;
            }

            this.linea.tipo_hora = null;
            this.linea.cantidad = 1;
            const prods = this.productosOrden(this.orden);
            if (prods.length) {
                this.linea.descripcion = "";
                this.linea.precio = 0;
            } else {
                const fecha_finalizada = this.orden.fecha_finalizada
                    ? new Date(this.orden.fecha_finalizada).toLocaleDateString()
                    : "Sin Asignar";
                this.linea.precio =
                    this.orden.importe - (this.orden.facturado ?? 0);
                this.linea.descripcion = `Nº Obra ${this.orden.nro_orden} ${
                    this.orden.id_presupuesto == null
                        ? ""
                        : `– Nº Presupuesto ${this.orden.id_presupuesto}`
                } – Fecha de finalización ${fecha_finalizada}`;

                if (this.orden.lineas_presupuesto) {
                    this.orden.lineas_presupuesto.forEach((element) => {
                        this.linea.descripcion += `\n- ${element.denominacion}: ${element.descripcion}`;
                    });
                }
            }
        },

        clavesTipoHora(tipo) {
            if (tipo === "normal") {
                return {
                    precio: "precio_hora_normal",
                    cantidad: "cantidad_hora_normal",
                };
            }
            if (tipo === "extra") {
                return {
                    precio: "precio_hora_extra",
                    cantidad: "cantidad_hora_extra",
                };
            }
            return {
                precio: "precio_hora_festivo",
                cantidad: "cantidad_hora_festivo",
            };
        },

        contribucionTipoProducto(prod, tipo) {
            const { precio, cantidad } = this.clavesTipoHora(tipo);
            return (
                (parseFloat(prod[precio]) || 0) *
                (parseFloat(prod[cantidad]) || 0)
            );
        },

        tipoPrincipalProducto(prod) {
            const tipos = ["normal", "extra", "festivo"];
            let mejorTipo = null;
            let mejorValor = 0;
            tipos.forEach((tipo) => {
                const valor = this.contribucionTipoProducto(prod, tipo);
                if (valor > mejorValor) {
                    mejorValor = valor;
                    mejorTipo = tipo;
                }
            });
            return mejorTipo;
        },

        productoExclusivoPorTipo(prods, tipo) {
            return prods.find((p) => {
                if (this.contribucionTipoProducto(p, tipo) <= 0) {
                    return false;
                }
                return ["normal", "extra", "festivo"]
                    .filter((t) => t !== tipo)
                    .every((t) => this.contribucionTipoProducto(p, t) <= 0);
            });
        },

        productoPorPrecioFila(prods, tipo) {
            const { precio: keyPrecio } = this.clavesTipoHora(tipo);
            return prods.find((p) => {
                const unit = parseFloat(p[keyPrecio]) || 0;
                const rowPrecio = parseFloat(p.precio) || 0;
                if (unit <= 0 || rowPrecio <= 0) {
                    return false;
                }
                return Math.abs(rowPrecio - unit) < 0.02;
            });
        },

        inferirTipoPorDescripcion(prod) {
            const d = (this.descripcionProductoOrden(prod) || "").toLowerCase();
            if (d.includes("festivo")) {
                return "festivo";
            }
            if (d.includes("noche") || d.includes("nocturn")) {
                return "extra";
            }
            if (d.includes("dia") || d.includes("día")) {
                return "normal";
            }
            return null;
        },

        productoOrdenPorTipoHora(prods, tipo) {
            if (!prods || !prods.length || !tipo) {
                return null;
            }

            let match = this.productoExclusivoPorTipo(prods, tipo);
            if (match) {
                return match;
            }

            match = prods.find(
                (p) => this.inferirTipoPorDescripcion(p) === tipo
            );
            if (match) {
                return match;
            }

            match = this.productoPorPrecioFila(prods, tipo);
            if (match) {
                return match;
            }

            const candidatos = prods.filter(
                (p) => this.tipoPrincipalProducto(p) === tipo
            );
            if (candidatos.length === 1) {
                return candidatos[0];
            }

            const { precio: keyPrecio } = this.clavesTipoHora(tipo);
            const otrasClaves = ["normal", "extra", "festivo"]
                .filter((t) => t !== tipo)
                .map((t) => this.clavesTipoHora(t).precio);

            match = prods.find((p) => {
                const precioTipo = parseFloat(p[keyPrecio]) || 0;
                if (precioTipo <= 0) {
                    return false;
                }
                return otrasClaves.every(
                    (k) => (parseFloat(p[k]) || 0) === 0
                );
            });
            if (match) {
                return match;
            }

            match = prods.find(
                (p) => this.contribucionTipoProducto(p, tipo) > 0
            );

            return match || prods[0];
        },

        precioUnitarioPorTipo(prod, tipo) {
            const { precio: keyPrecio, cantidad: keyCantidad } =
                this.clavesTipoHora(tipo);
            const cantProd = parseFloat(prod[keyCantidad]) || 0;
            const rowPrecio = parseFloat(prod.precio) || 0;
            const esExclusivo = !!this.productoExclusivoPorTipo([prod], tipo);
            const tipoDesc = this.inferirTipoPorDescripcion(prod) === tipo;
            const contrib = this.contribucionTipoProducto(prod, tipo);

            if (cantProd > 0 && contrib > 0) {
                return contrib / cantProd;
            }

            if (rowPrecio > 0 && (esExclusivo || tipoDesc)) {
                if (cantProd > 0) {
                    return rowPrecio / cantProd;
                }
                return rowPrecio;
            }

            const unitCatalogo = parseFloat(prod[keyPrecio]) || 0;
            if (unitCatalogo > 0) {
                return unitCatalogo;
            }

            if (rowPrecio > 0 && cantProd > 0) {
                return rowPrecio / cantProd;
            }

            return rowPrecio > 0 ? rowPrecio : 0;
        },

        descripcionProductoOrden(prod, tipo) {
            if (!prod) {
                return "";
            }
            const custom = prod.descripcion
                ? String(prod.descripcion).trim()
                : "";
            if (custom) {
                return custom;
            }
            const catalogo =
                (prod.Producto && prod.Producto.descripcion) ||
                (prod.producto && prod.producto.descripcion) ||
                (prod.Producto && prod.Producto.titulo) ||
                (prod.producto && prod.producto.titulo) ||
                "";
            if (!catalogo) {
                return "";
            }
            if (!tipo) {
                return String(catalogo).trim();
            }
            const opcion = this.opcionesTipoHora.find((o) => o.value === tipo);
            const etiqueta = opcion ? opcion.label : tipo;
            return `${String(catalogo).trim()} (${etiqueta})`;
        },

        aplicarPrecioCantidadPorTipoHora(lineaObj) {
            const linea = lineaObj || this.linea;
            const orden =
                lineaObj === this.editlinea
                    ? this.findOrden(linea.id_orden)
                    : this.orden;
            const prods = this.productosOrden(orden);
            if (!orden || !prods.length || !linea.tipo_hora) {
                return;
            }
            const tipo = linea.tipo_hora;
            const prod = this.productoOrdenPorTipoHora(prods, tipo);
            if (!prod) {
                return;
            }

            const precio = this.precioUnitarioPorTipo(prod, tipo);
            this.$set(
                linea,
                "precio",
                precio > 0 ? parseFloat(Number(precio).toFixed(2)) : precio
            );
            this.$set(linea, "cantidad", 1);
            this.$set(linea, "descripcion", this.descripcionProductoOrden(prod, tipo));
        },

        // Funciones extras que cargan informacion general de la factura
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },
        getPresupuesto() {
            axios
                .get(`api/getpresupuesto/${this.$route.query.id_presupuesto}`)
                .then(
                    (res) => {
                        this.factura.id_presupuesto = res.data.id;
                        this.presupuesto = res.data;
                        if (this.$route.query.id == null) {
                            this.factura.id_cliente = res.data.id_cliente;
                            this.factura.lineas = [
                                {
                                    articulo:
                                        'Anticipo de presupuesto nº "' +
                                        this.$route.query.id_presupuesto +
                                        '"',
                                    cantidad: 1,
                                    precio: this.total,
                                    subtotal: this.total,
                                    descripcion:
                                        'Anticipo de presupuesto nº "' +
                                        this.$route.query.id_presupuesto +
                                        '"',
                                    dcto: 0,
                                    total: this.total,
                                },
                            ];

                            // Accede al total desde el store
                            //this.total = this.obtenerTotal();
                        }
                    },
                    (res) => {}
                );
        },

        // Obtiene el total del store
        obtenerTotal() {
            const total = this.$store.getters.getTotal;
            return total;
        },
        BaseFromTotal() {
            const precio_total =
                this.editlinea.precio_total / this.editlinea.cantidad;
            this.editlinea.precio = parseFloat(precio_total.toFixed(2));
        },
        TotalFromBase() {
            const precio_total =
                this.editlinea.precio * this.editlinea.cantidad;
            this.editlinea.precio_total = parseFloat(precio_total.toFixed(2));
        },
        redondearPctDcto(item) {
            if (!item.precio || !item.cantidad) return item.dcto;
            const base = item.precio * item.cantidad;
            if (base <= 0) return item.dcto;
            const pct = (item.dcto / base) * 100;
            return Math.round(pct * 100) / 100;
        },

        // Agrega un anticipo de factura
        addAnticipo() {
            addFacturaAnticipoNegativa(
                this.factura.lineas,
                this.orden.id_presupuesto,
                this.$route.meta.nota == 1 ? "nota" : "factura"
            );
        },

        // Abre un modal para crear asiento contable desde este formulario
        openAsiento() {
            this.asiento_dialog = true;
        },

        formatPrice,

        // FUNCIONES INUTILIZADAS:
        // No esta siendo llamada
        /*setClienteByPresupuesto(val) {
            let item = this.presupuestos.find((element) => {
                return element.id == val;
            });
            // console.log("item", item);
            this.factura.id_cliente = item.id_cliente;
            this.factura.cliente = item.clientela;
            this.presupuesto = item;
            this.$store.dispatch("addCliente", item.clientela);
        },*?

        // Ya no se redirige a este formulario desde facturacion sino que se crea directamente la factura desde alla
        // Establecer la data de la factura segun la data enviada en el state (ordenes o albaranes de venta) desde "facturacion"
        /*async setDataFacturaOrden() {
            this.factura.id_cliente = this.state_ordenes[0].id_cliente

            for (const element of this.state_ordenes) {
                // Use this.$set for nested properties
                this.$set(this.linea, "id_orden", element.id);
                this.linea.precio = element.importe;

                // Espera a que el watcher y selectOrdenCliente terminen
                await this.selectOrdenCliente();

                // Luego añade la línea
                this.addLinea();
            }
        },
        async setDataFacturaAlbaran() {
            this.factura.id_cliente = this.state_albaran_venta[0].id_cliente

            for (const element of this.state_albaran_venta) {
                // Use this.$set for nested properties
                this.$set(this.linea, 'id_albaran_venta', element.id);
                // Espera a que el watcher y selectAlbaranVentaCliente terminen
                await this.selectAlbaranVentaCliente();

                // Luego añade la línea
                this.addLinea();
            }
        },
        openDescripcion() {
            if (!this.$refs.linea_form.validate()) return;
            // this.linea.descripcion = this.productos.find(
            //     (element) => element.id == this.linea.id_producto
            // ).descripcion;

            this.product_dialog = true;
        },
        formatNumber(number) {
            if (number == null) return "null";
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },*/
    },
    computed: {
        esTransferenciaBancaria() {
            if (!this.factura.id_metodo_pago || !this.metodosDePago.length)
                return false;
            const metodo = this.metodosDePago.find(
                (m) => m.id == this.factura.id_metodo_pago
            );
            return (
                metodo &&
                metodo.nombre &&
                metodo.nombre.toLowerCase().includes("transferencia")
            );
        },
        presupuestos() {
            return this.$store.getters.getpresupuestos;
        },
        facturaAsiento() {
            const factura = { ...this.factura };
            factura.subtotal = factura.total;
            factura.valor_iva = this.importeIva;
            factura.total = factura.subtotal + factura.valor_iva;
            factura.iva = this.$route.meta.nota ? 0 : this.factura.iva;
            return factura;
        },
        lineasHeaders() {
            const headers = [...this.headersBase];
            if (this.$route.meta.nota == 0) {
                headers.splice(headers.length - 1, 0, {
                    text: "IVA",
                    value: "iva_pct",
                    sortable: false,
                });
            }
            return headers;
        },
        lineaIvaPorcentaje: {
            get() {
                return this.ivaPorLinea(this.linea);
            },
            set(porcentaje) {
                this.asignarIvaPorcentaje(this.linea, porcentaje);
            },
        },
        opcionesIvaLinea() {
            return [
                { text: "21 %", value: 21 },
                { text: "10 %", value: 10 },
                { text: "0 %", value: 0 },
            ];
        },
        showTipoHoraLinea() {
            const prods = this.productosOrden(this.orden);
            return (
                this.tipo_linea == 0 &&
                this.linea.id_orden &&
                this.orden &&
                prods.length > 0
            );
        },
        lineaOrdenMd() {
            return this.showTipoHoraLinea ? 2 : 3;
        },
        lineaDescMd() {
            if (this.tipo_linea == 1) {
                return 10;
            }
            if (this.showTipoHoraLinea) {
                return 6;
            }
            return 7;
        },
        lineaDctoMd() {
            return this.$route.meta.nota == 0 ? 2 : 3;
        },
        lineaBtnMd() {
            return this.$route.meta.nota == 0 ? 3 : 4;
        },
        editlineaIvaPorcentaje: {
            get() {
                return this.ivaPorLinea(this.editlinea);
            },
            set(porcentaje) {
                this.asignarIvaPorcentaje(this.editlinea, porcentaje);
            },
        },
        desgloseDetalle() {
            const a = this.refresh_key;
            return this.calcularDesgloseDetalle();
        },
        desgloseCuotas() {
            const a = this.refresh_key;
            return this.calcularDesgloseCuotas();
        },
        tiposIvaEnTotales() {
            const a = this.refresh_key;
            const d = this.desgloseDetalle;
            return [21, 10, 0].filter((tipo) => d[tipo].count > 0);
        },
        importeIva() {
            const a = this.refresh_key;
            const d = this.desgloseCuotas;
            return d.iva_21 + d.iva_10 + d.iva_0;
        },
        totalConIva() {
            if (this.$route.meta.nota == 1) {
                return this.total;
            }
            return this.total + this.importeIva;
        },
        total() {
            const a = this.refresh_key;
            let total = 0;
            if (this.$route.query.id_presupuesto != null) {
                // Accede al total desde el store
                total = this.obtenerTotal();
                if (total == 0) {
                    this.factura.lineas.forEach((elemento) => {
                        total += elemento.total;
                    });
                }
            } else {
                this.factura.lineas.forEach((elemento) => {
                    total += elemento.total;
                });
            }
            this.factura.total = total;
            this.syncDesgloseIva();

            return total;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
        clientes() {
            let clientes_temp = this.$store.getters.getclientes;
            if (this.presupuesto != null)
                if (this.presupuesto.clientela != null) {
                    clientes_temp.push(this.presupuesto.clientela);
                }
            return clientes_temp;
        },
        pedidos() {
            /////console.log("siva");
            let pedidos_temp = this.$store.getters.getpedidos;

            return pedidos_temp;
        },
        lineas_pedido() {
            let pedidos_temp = this.$store.getters.getlineaspedido;

            return pedidos_temp;
        },

        // Como ya no se redirige a este formulario desde facturacion sino que se crea directamente la factura desde alla
        // no es necesario utilizar los estados
        // state de vuex seteado desde "facturacion" que trae las ordenes para crear la factura
        /*state_ordenes() {
            const data = this.$store.getters.getOrdenesData;
            return data
        },
        // state de vuex seteado desde "facturacion" que trae los albaranes para crear la factura
        state_albaran_venta(){
            const data = this.$store.getters.getAlbaranVentaData;
            return data
        },*/

        /*metodos_pagos(){
            let metodos_pedidos = this.$store.getters.getmetodopedido;
            return metodos_pedidos;
        }*/
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
.spacing {
    padding-top: 0 !important;
}
.linea-orden-selection {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.linea-fila-importes .linea-dcto-toggle-col {
    align-self: center;
}
</style>
